<span>
    <input class="k-checkbox list-cell-checkbox" disabled [checked]="value" type="checkbox" kendoCheckBox>
</span>